<template>
	<div class="page-content users-table-view">
		<div class="container-fluid">
			<Affix :offset-top="0" class="affix-header-style">
				<Card>
					<Row class="d-flex align-items-center">
						<Col span="10">
						<span class="page-title" v-if="competition">{{ competition.name }} | {{ getCategory().name }} |
							<span v-if="competition && competition.stages.find(({ isCurrent }) => isCurrent)" class="mt-3 mb-4">
								{{ $t('competition.current') }} - {{ competition.stages.find(({ isCurrent }) => isCurrent).name }}
							</span></span>
						</Col>
						<Col span="14">
						<div v-if="isVisible" class="text-right">
							<Button @click="() => save()" :disabled="!canSave" size="large" type="info"> {{ $t('global.save')
							}}</Button>
						</div>
						<div v-else-if="!loading" class="text-right">
							<Button v-if="competition.stages.findIndex(({ isCurrent }) => isCurrent) > 0" @click="() => previousStage()"
								size="large" type="info">
								{{ $t('competition.previous') }}</Button>
							<Button class="mr-1" v-for="(comp, i) in competition.stages.filter((comp) => comp.rounds.length)"
								:key="comp._id" :disabled="comp._id === competition.stages.find(({ isCurrent }) => isCurrent)._id"
								@click="() => setStage(comp._id)" size="large" type="info">{{ i + 1 }}</Button>
							<Button
								v-if="competition.stages.findIndex(({ isCurrent }) => isCurrent) < competition.stages.length - 1 && nextStageIsAvailable"
								@click="() => nextStage()" size="large" type="info">
								{{ $t('competition.next') }}</Button>

							<Button
								v-if="type === 'circuit' && competition.stages.findIndex(({ isCurrent }) => isCurrent) < competition.stages.length - 1 && !matches.filter(({ isFinished }) => !isFinished).length && !nextStageIsAvailable"
								@click="() => detectCurrentStage()" size="large" type="info">
								{{ $t('competition.next') }}</Button>
							<Button
								v-else-if="type === 'circuit' && competition.stages.findIndex(({ isCurrent }) => isCurrent) === competition.stages.length - 1 && !matches.filter(({ isFinished }) => !isFinished).length && !competition.isCompleted"
								@click="() => finishCompetition()" size="large" type="info">
								{{ $t('competition.finish') }}</Button>
						</div>
						</Col>
					</Row>
				</Card>
			</Affix>

			<Spin v-if="loading" fix>
				<Icon class="demo-spin-icon-load" size="40" type="ios-loading"></Icon>
				<div>{{ $t('global.loading') }}</div>
			</Spin>

			<Row v-else style="margin-top: 20px;" :gutter="16" class="d-flex">
				<Col :span="(!isVisible && !showFinalStandings) ? 24 : 18">
				<div class="align-items-start justify-content-between">
					<div class="d-flex flex-column align-items-start">
						<div v-if="isVisible" class="">
							<div>
								<h5 class="mb-2">{{ $t('competition.choose_format') }}</h5>
								<RadioGroup v-model="type" class="d-flex flex-wrap">
									<Radio label="group" class="ttypes-radio-style">{{ $t('competition.groups') }}</Radio>
									<Radio label="circuit" class="ttypes-radio-style">{{ $t('competition.circuit') }}</Radio>
								</RadioGroup>
							</div>
							<div v-if="type === 'circuit'" class="mt-4">
								<h5 class="mb-2">{{ $t('competition.choose_spec') }}</h5>
								<RadioGroup v-model="spec" class="d-flex flex-wrap">
									<Radio label="oneway" class="ttypes-radio-style">{{ $t('competition.circuit1') }}</Radio>
									<Radio label="twoway" class="ttypes-radio-style">{{ $t('competition.circuit2') }}</Radio>
								</RadioGroup>
							</div>
							<div v-else-if="type === 'group'">
								<div class="mt-4">
									<h5 class="mb-2">{{ $t('competition.choose_spec') }}</h5>
									<RadioGroup v-model="spec" class="d-flex flex-wrap">
										<Radio label="stepladder" class="ttypes-radio-style">Stepladder</Radio>
										<Radio label="single" class="ttypes-radio-style">Single Elimination</Radio>
										<Radio label="wildcard" class="ttypes-radio-style">Wild Card</Radio>
									</RadioGroup>
								</div>
								<div class="mt-4">
									<h5 class="mb-2">{{ $t('competition.choose_qty') }}</h5>
									<RadioGroup v-model="qty" class="d-flex flex-wrap justify-content-between">
										<Radio label="2" class="ttypes-radio-style">2</Radio>
										<Radio label="3" :disabled="spec === 'stepladder' || spec === 'wildcard'" class="ttypes-radio-style">3
										</Radio>
										<Radio label="4" :disabled="spec === 'stepladder'" class="ttypes-radio-style">4</Radio>
									</RadioGroup>
								</div>
							</div>
						</div>
						<div class="w-100">
							<GroupsBlock v-if="type === 'group' && spec && qty && renderComponent" />
							<RoundsBlock v-if="type === 'group' && spec && qty && renderComponent" />

							<!-- <Circuit v-if="type === 'circuit' && spec && renderComponent" />
								<Group v-if="type === 'group' && spec && qty && renderComponent" /> -->
						</div>
					</div>
				</div>
				</Col>
				<Col v-if="showFinalStandings" :span="!showFinalStandings ? 0 : 6" style="padding-bottom: 1rem;">
				<Card style="height: 100%;" class="table-card-style">
					<ShowFinalStandings />
				</Card>
				</Col>
				<Col v-if="isVisible && type" :span="!isVisible ? 0 : 6" style="padding-bottom: 1rem;">
				<Card style="height: 100%;" class="table-card-style">
					<FormatLegend />
				</Card>
				</Col>
			</Row>
			<Row>
				<Circuit v-if="type === 'circuit' && spec && renderComponent" />
				<Group v-if="type === 'group' && spec && qty && renderComponent" />
			</Row>
		</div>
	</div>
</template>

<script>
import Circuit from './formats/Circuit.vue';
import Group from './formats/Group.vue';
import ShowFinalStandings from './formats/groups/ShowFinalStandings.vue';
import storeMixin from './formats/storeMixin';
import GroupsBlock from './formats/groups/GroupsBlock.vue';
import RoundsBlock from './formats/groups/RoundsBlock.vue';
import FormatLegend from './formats/groups/FormatLegend.vue';

export default {
	components: { Circuit, Group, ShowFinalStandings, GroupsBlock, RoundsBlock, FormatLegend },
	data() {
		return storeMixin;
	},
	async created() {
		// this.loading = true;
		await this.getCurrentCompetition(true);

		if (this.competition.stages.length && this.competition.stages.findIndex(({ isCurrent }) => isCurrent) !== this.competition.stages.length - 1) {
			console.log('a')
			await this.checkStageAvailability([this.competition.stages[this.competition.stages.findIndex(({ isCurrent }) => isCurrent) + 1]]);
		}
		// console.log(this.competition.stages);
		// console.log(this.single.map(({ round }) => round._id));
		// console.log(this.groupStageFinished);
		// console.log(this.competition.stages.flatMap(({ rounds }) => rounds.flatMap((round) => { return !round.isPlayoff ? round : this.single.some((match) => match.round._id === round._id) ? round : round._id })));
		// this.loading = false
		this.getCategory();
	},
	watch: {
		type(value) {
			if (this.isVisible) {
				this.type = value;
				this.spec = null;
				this.qty = null;
				this.canSave = false
				this.matches = [];
				this.rounds = [];
				this.canSave = false

			}
		},
		async spec(value) {
			if (this.isVisible) {
				this.spec = value;
				this.qty = null;
				this.matches = [];
				this.rounds = [];
				this.canSave = false

				if (this.type === 'circuit') {
					await this.getCurrentTeams();
					this.canSave = true
					this.canSave = true
				}
			}
		},
		async qty(value) {
			if (this.isVisible) {
				this.qty = value;
				this.matches = [];
				this.rounds = [];
				this.canSave = false
				this.getCategory();
				this.canSave = false
				await this.getCurrentTeams();
			}
		},
	},
};
</script>

<style scoped>
.affix-header-style {
	position: relative;
	z-index: 99 !important;
}

.min-vh-90 {
	min-height: 90vh;
}

.page-title {
	border: 0;
}

.ttypes-radio-style.ivu-radio-wrapper {
	margin: 0 4px 8px 4px;
	width: 150px;
	height: 50px;
	padding: 5px;
	background: #f3f3f3;
	border-radius: 10px;
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	overflow: hidden;
	font-size: 13px;
	font-weight: bold;
}

.ttypes-radio-style:hover {
	background: #e4e4e4;
}

.ttypes-radio-style.ivu-radio-wrapper {
	text-wrap: wrap;
	line-height: 1;
	text-align: center;
}

.ttypes-radio-style :global(.ivu-radio) {
	display: none !important;
	position: absolute;
	top: -25px;
	left: -25px;
	transform: rotate(45deg);
}

.ttypes-radio-style :global(.ivu-radio .ivu-radio-inner) {
	border-radius: 0;
	width: 42px;
	height: 42px;
	background: #5abb73;
	border-color: #5abb73;
}

.ttypes-radio-style :global(.ivu-radio .ivu-radio-inner:after) {
	top: auto;
	left: auto;
	bottom: 15px;
	right: 2px;
	transform: rotate(0deg);
	width: 7px;
	height: 13px;
	border: 3px solid #ffffff;
	border-top: 0;
	border-left: 0;
}

.ttypes-radio-style :global(.ivu-radio .ivu-radio-inner:after) {
	border-radius: 0;
	background: none;
}

.ttypes-radio-style.ivu-radio-wrapper-checked {
	border: 3px solid #5abb73;
}

.ttypes-radio-style.ivu-radio-wrapper-checked :global(.ivu-radio) {
	display: inline-block !important;
}
</style>



// WEBPACK FOOTER //
// src/components/competitions/schemes/SchemaSelect.vue